/*
  Powdered-sugar meter.

  The meter is server-rendered correctly by main-cart-items.liquid, so this
  file is pure progressive enhancement: without it the meter is still right
  on page load, it just will not react to quantity changes made in place.

  It listens on Dawn's existing cart-update pub/sub event (published by
  cart.js) rather than observing the DOM, and it lives outside .js-contents
  so the section swap never removes it.
*/
(function () {
  'use strict';

  var SELECTOR = '[data-bb-cart-meter]';

  function getMeter() {
    return document.querySelector(SELECTOR);
  }

  function formatMoney(cents, currency) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function render(meter, totalPrice, itemCount) {
    var threshold = parseInt(meter.dataset.threshold, 10);
    if (!threshold || threshold <= 0) return;

    // An emptied cart hands the page back to the branded empty state.
    if (itemCount === 0) {
      meter.hidden = true;
      return;
    }
    meter.hidden = false;

    var remaining = Math.max(threshold - totalPrice, 0);
    var pct = Math.min(Math.floor((totalPrice * 100) / threshold), 100);
    var unlocked = remaining === 0;

    var fill = meter.querySelector('[data-bb-cart-meter-fill]');
    if (fill) fill.style.setProperty('--bb-meter-pct', String(pct));

    var track = meter.querySelector('[role="progressbar"]');
    if (track) track.setAttribute('aria-valuenow', String(totalPrice));

    var message = meter.querySelector('[data-bb-cart-meter-message]');
    if (message) {
      var next = unlocked
        ? meter.dataset.messageUnlocked
        : (meter.dataset.messageAway || '').replace(
            '[[amount]]',
            formatMoney(remaining, meter.dataset.currency)
          );
      // Only touch the DOM when the wording actually changed, so the
      // aria-live region announces once per real change rather than on
      // every quantity tick.
      if (message.textContent.trim() !== next.trim()) {
        message.textContent = next;
      }
    }

    meter.classList.toggle('is-unlocked', unlocked);
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var meter = getMeter();
      if (!meter) return;

      var data = event && event.cartData;
      if (data && typeof data.total_price === 'number') {
        render(meter, data.total_price, data.item_count);
        return;
      }

      // Some publishers omit the cart payload; ask for the truth instead.
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          render(meter, cart.total_price, cart.item_count);
        })
        .catch(function () {
          /* Leave the server-rendered state in place. */
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
